import { EChartOption } from 'echarts';
import moment from 'moment/moment';
import { IssueTimeType } from '@/proto/issue';

export const DEFAULT_ECHART_XAXIS_CONFIG: EChartOption.XAxis = {
  type: 'category',
  axisLine: {
    lineStyle: {
      color: '#E8E8EA',
    },
  },
  axisTick: {
    show: true,
    alignWithLabel: true,
  },
  axisPointer: {
    lineStyle: {
      type: 'dashed',
      color: '#E8E8EA',
    },
  },
};

export const DEFAULT_ECHART_YAXIS_CONFIG: EChartOption.YAxis = {
  type: 'value',
  axisLine: {
    lineStyle: {
      color: '#E8E8EA',
    },
  },
  splitLine: {
    lineStyle: {
      color: '#E8E8EA',
    },
  },
  axisTick: {
    show: false,
  },
};

export const DEFAULT_ECHART_GRID = {
  left: 0,
  right: 0,
  containLabel: true,
};

export const DEFAULT_ECHART_SERIRES_LINE_CONFIG: EChartOption.SeriesLine = {
  type: 'line',
  lineStyle: {
    color: '#0062FF',
  },
  itemStyle: {
    color: '#0062FF',
  },
  areaStyle: {
    color: {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0, color: '#CFDEFC',
      }, {
        offset: 1, color: '#fff',
      }],
      global: false,
    },
  },
  showSymbol: true,
  symbol: 'circle',
  emphasis: {
    itemStyle: {
      borderColor: '#0062FF',
      color: '#FFFFFF',
    },
  },
};

export const DEFAULT_ECHART_COLORS = ['#FFC542', '#A461D8', '#FF974A', '#3DD598', '#fc5a5a', '#eb2f96'];
export const DEFAULT_BAR_COLOR = '#50B5FF';
export const DEFAULT_LEGEND_COLOR = '#A3A3A9';
export const DEFAULT_TEXT_COLOR = '#A3A3A9';
export const DEFAULT_BAR_MAX_WIDTH = '40px';
export const DEFUALT_SPLIT_NUMBER = 5;
export const RISK_ECHART_COLORS = ['#DB3543', '#F57E22', '#0062FF'];
export const LINER_ECHART_COLORS = ['#3C9FE5', '#00C788', '#FAC228', '#0056D6'];
export const FLARE_ECHART_COLORS = ['#fc5a5a', '#3DD598', '#FF974A'];


export const undone = (params: { name: moment.MomentInput; color: any; }, timeWindow?: number) => {
  const date = moment(params.name);
  if (timeWindow === IssueTimeType.TIME_TYPE_DAY && moment().diff(date, 'days') === 0) {
    return {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0, color: params.color, // 0% 处的颜色
      }, {
        offset: 1, color: '#fff', // 100% 处的颜色
      }],
      global: false, // 缺省为 false
    };
  }
  return params.color;
};
